import parse from 'html-react-parser';

import ApiState from '@/components/ApiState/ApiState';
import ChapterNav from '@/components/ChapterNav/ChapterNav';
import Layout from '@/components/Layout/Layout';
import Overlay from '@/components/Overlay/Overlay';
import { Bibliography, Links } from '@/components/Resources';
import { useAdjacentPages } from '@/store/useAdjacentPages';
import { useBodyClass } from '@/hooks/useBodyClass';
import { useLearnMore } from '@/api/useThesaurusTerm';

import segellsColor from '@/assets/img/overlays/segells-color@2x.png';

function LearnMore({ page }) {
    useBodyClass('has-background-light');
    const { prev, next } = useAdjacentPages(page.web_path);
    const { data, isLoading, error } = useLearnMore(page.section_id);
    const learnMoreContent = data?.[0];
    const { title, abstract, body, uri, bibliography_data } = learnMoreContent ?? {};
    const links = uri ? JSON.parse(uri) : [];

    return (
        <Layout>
            <title>{page.term}</title>
            <div className="overlay-space is-hidden-touch">
                <Overlay
                    src={segellsColor}
                    style={{
                        top: -28,
                        left: '55%',
                        transform: 'translateX(-50%)',
                        zIndex: 8,
                        maxWidth: 386,
                        opacity: 0.8,
                    }}
                />
            </div>
            <div className="wrapper py-8">
                <ApiState isLoading={isLoading} error={error}>
                    <div className="columns is-desktop gap-6">
                        <div className="column is-two-fifths-desktop">
                            <div className="flow has-text-weight-light">
                                <h1 className="has-text-primary is-uppercase is-family-secondary">
                                    {title}
                                </h1>
                                {abstract && <p>{parse(abstract)}</p>}
                            </div>
                        </div>
                    </div>
                    {body && <div className="flow mt-8">{parse(body)}</div>}
                    <div className="flow--2xs mt-8">
                        <div className="chapter-resources">
                            <Bibliography bibliography={bibliography_data} />
                            <Links links={links} />
                        </div>
                    </div>
                </ApiState>

                <ChapterNav prev={prev} next={next} />
            </div>
        </Layout>
    );
}

export default LearnMore;
